<script lang="ts">
  import { getContext } from "svelte"
  import { hexToRgba } from "lib/helpers"
  import type { Theme } from "website_script/types/theme"
  import type { Settings } from "website_script/types/settings"
  import type { Texts } from "website_script/types/texts"

  let { iframeHost, footerLogoUrl } = getContext<Settings>("settings")
  const { accentColor, neutralTextColor, textCtaColor } =
    getContext<Theme>("theme")
  let { poweredBy } = getContext<Texts>("texts")

  /** The message for the chat */
  export let message: string
  export let extraMessage: string | null = ""
  /** Who it will appear the message is from */
  export let sender: string | null

  /**
   * Returns current time in format H:MM
   */
  const getCurrentTime = () => {
    const d = new Date()
    const hour = d.getHours()
    const minute = d.getMinutes()
    return `${hour}:${minute < 10 ? "0" : ""}${minute}`
  }
</script>

<!--
@component

This shows a small chat like card with the given message and the given sender
-->
<div
  style={`
    --accent-color: ${accentColor};
    --faded-neutral-color: ${hexToRgba(neutralTextColor, 0.5)};
    --text-cta-color: ${textCtaColor};
    --neutral-text-color: ${neutralTextColor};
    --shadow-color: ${hexToRgba(neutralTextColor, 0.35)};
    --border-color: ${hexToRgba(neutralTextColor, 1)};
    --focused-border-color: ${hexToRgba(neutralTextColor, 0.75)}
  `}
>
  <div class="auws-chat">
    <div class="auws-message">
      {@html message}
    </div>
    {#if extraMessage}
      <div class="auws-message">
        {@html extraMessage}
      </div>
    {/if}
    {#if sender}
      <div class="auws-sender">
        {getCurrentTime()} - {sender}
      </div>
    {/if}
  </div>
  <div class="auws-center">
    <slot name="call-to-action" />
  </div>
  <div class="auws-footer">
    {poweredBy}
    <a href={iframeHost} target="_blank" class="auws-footer-link">
      <img class="auws-footer-logo" src={footerLogoUrl} alt="AutoUncle" />
    </a>
  </div>
</div>

<style>
  .auws-sender {
    font-size: 10px;
    color: var(--neutral-color);
  }
  .auws-message {
    /* Restrict the width of the message so it doesn"t look too long */
    max-width: 200px;
    text-align: left;
    margin-right: 40px;
    color: var(--text-cta-color);
    font-size: 14px;
    line-height: 16px;
    padding: 6px 12px;
    border-radius: 6px 6px 6px 0px;
    margin-bottom: 4px;
    display: inline-block;
    position: relative;
    background-color: var(--accent-color);
    box-shadow: 0px 1px 4px var(--shadow-color);
  }

  .auws-footer {
    font-size: 8px;
    text-align: right;
    padding-top: 6px;
    color: var(--neutral-text-color);
  }
  .auws-footer-link {
    display: inline;
    text-decoration: none;
    padding: 0;
    margin: 0;
  }
  .auws-footer-logo {
    height: 6px;
    width: auto;
    display: inline;
    margin: 0;
  }
  .auws-footer {
    font-size: 8px;
    text-align: right;
    padding-top: 6px;
    color: var(--neutral-text-color);
  }
  .auws-footer-link {
    display: inline;
    text-decoration: none;
    padding: 0;
    margin: 0;
  }
  .auws-sender {
    padding: 4px 0px 5px 0px;
    color: #09366d;
    opacity: 45%;
  }
  .auws-center {
    margin: 5px 0px 5px 0px;
  }

  @media screen and (max-width: 760px) {
    .auws-sender {
      padding: 0;
    }

    .auws-footer {
      padding-top: 4px;
    }
  }
</style>
